'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _effects = require('redux-saga/effects');

var _lawSync = require('../actions/lawSync');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchProposals),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchProposal),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(fetchSyncOptions),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(approveClause),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(rejectClause),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(editProposalClause),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(watchFetchProposals),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchFetchProposal),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(watchFetchSyncOptions),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(watchApproveClause),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(watchRejectClause),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(watchEditProposalClause);

function fetchProposals(_ref) {
    var _ref$filters = _ref.filters,
        filters = _ref$filters === undefined ? {} : _ref$filters;

    var _filters$page, page, _filters$pageSize, pageSize, status, title, normType, yearFrom, yearTo, params, response, _ref2, proposals, total;

    return regeneratorRuntime.wrap(function fetchProposals$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _filters$page = filters.page, page = _filters$page === undefined ? 0 : _filters$page, _filters$pageSize = filters.pageSize, pageSize = _filters$pageSize === undefined ? 20 : _filters$pageSize, status = filters.status, title = filters.title, normType = filters.normType, yearFrom = filters.yearFrom, yearTo = filters.yearTo;
                    params = { offset: page * pageSize, limit: pageSize };

                    if (status) params.status = status;
                    if (title) params.title = title;
                    if (normType) params.normType = normType;
                    if (yearFrom) params.yearFrom = yearFrom;
                    if (yearTo) params.yearTo = yearTo;
                    _context.next = 10;
                    return (0, _effects.call)(_api.request, 'get', '/lawsync/proposals', params);

                case 10:
                    response = _context.sent;
                    _ref2 = response.data || {}, proposals = _ref2.proposals, total = _ref2.total;
                    _context.next = 14;
                    return (0, _effects.put)(_lawSync.actionCreators.fetchProposalsSucceeded(proposals, total, page));

                case 14:
                    _context.next = 20;
                    break;

                case 16:
                    _context.prev = 16;
                    _context.t0 = _context['catch'](0);
                    _context.next = 20;
                    return (0, _effects.put)(_lawSync.actionCreators.fetchProposalsFailed(_context.t0.response ? _context.t0.response.data : _context.t0));

                case 20:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 16]]);
}

function fetchProposal(_ref3) {
    var id = _ref3.id;
    var response;
    return regeneratorRuntime.wrap(function fetchProposal$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/lawsync/proposals/' + id);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_lawSync.actionCreators.fetchProposalSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_lawSync.actionCreators.fetchProposalFailed(_context2.t0.response ? _context2.t0.response.data : _context2.t0));

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function fetchSyncOptions() {
    var _ref4, _ref5, categories, objectives;

    return regeneratorRuntime.wrap(function fetchSyncOptions$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.all)([(0, _effects.call)(_api.request, 'get', '/lawsync/categories'), (0, _effects.call)(_api.request, 'get', '/lawsync/objectives')]);

                case 3:
                    _ref4 = _context3.sent;
                    _ref5 = _slicedToArray(_ref4, 2);
                    categories = _ref5[0];
                    objectives = _ref5[1];
                    _context3.next = 9;
                    return (0, _effects.put)(_lawSync.actionCreators.fetchSyncOptionsSucceeded(categories.data, objectives.data));

                case 9:
                    _context3.next = 15;
                    break;

                case 11:
                    _context3.prev = 11;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 15;
                    return (0, _effects.put)(_lawSync.actionCreators.fetchSyncOptionsFailed(_context3.t0.response ? _context3.t0.response.data : _context3.t0));

                case 15:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 11]]);
}

function approveClause(_ref6) {
    var proposalId = _ref6.proposalId,
        clauseId = _ref6.clauseId,
        payload = _ref6.payload;
    var response;
    return regeneratorRuntime.wrap(function approveClause$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/lawsync/proposals/' + proposalId + '/clauses/' + clauseId + '/approve', payload || {});

                case 3:
                    response = _context4.sent;
                    _context4.next = 6;
                    return (0, _effects.put)(_lawSync.actionCreators.approveClauseSucceeded(clauseId, response.data));

                case 6:
                    _context4.next = 12;
                    break;

                case 8:
                    _context4.prev = 8;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 12;
                    return (0, _effects.put)(_lawSync.actionCreators.approveClauseFailed(clauseId, _context4.t0.response ? _context4.t0.response.data : _context4.t0));

                case 12:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 8]]);
}

function rejectClause(_ref7) {
    var proposalId = _ref7.proposalId,
        clauseId = _ref7.clauseId;
    var response;
    return regeneratorRuntime.wrap(function rejectClause$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.prev = 0;
                    _context5.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/lawsync/proposals/' + proposalId + '/clauses/' + clauseId + '/reject', {});

                case 3:
                    response = _context5.sent;
                    _context5.next = 6;
                    return (0, _effects.put)(_lawSync.actionCreators.rejectClauseSucceeded(clauseId, response.data));

                case 6:
                    _context5.next = 12;
                    break;

                case 8:
                    _context5.prev = 8;
                    _context5.t0 = _context5['catch'](0);
                    _context5.next = 12;
                    return (0, _effects.put)(_lawSync.actionCreators.rejectClauseFailed(clauseId, _context5.t0.response ? _context5.t0.response.data : _context5.t0));

                case 12:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[0, 8]]);
}

function editProposalClause(_ref8) {
    var proposalId = _ref8.proposalId,
        clauseId = _ref8.clauseId,
        payload = _ref8.payload,
        onSuccess = _ref8.onSuccess;
    var response;
    return regeneratorRuntime.wrap(function editProposalClause$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.prev = 0;
                    _context6.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/lawsync/proposals/' + proposalId + '/clauses/' + clauseId, payload);

                case 3:
                    response = _context6.sent;
                    _context6.next = 6;
                    return (0, _effects.put)(_lawSync.actionCreators.editProposalClauseSucceeded(clauseId, response.data));

                case 6:
                    if (onSuccess) onSuccess();
                    _context6.next = 13;
                    break;

                case 9:
                    _context6.prev = 9;
                    _context6.t0 = _context6['catch'](0);
                    _context6.next = 13;
                    return (0, _effects.put)(_lawSync.actionCreators.editProposalClauseFailed(clauseId, _context6.t0.response ? _context6.t0.response.data : _context6.t0));

                case 13:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this, [[0, 9]]);
}

function watchFetchProposals() {
    return regeneratorRuntime.wrap(function watchFetchProposals$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_lawSync.actionTypes.FETCH_PROPOSALS_REQUEST, fetchProposals);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}
function watchFetchProposal() {
    return regeneratorRuntime.wrap(function watchFetchProposal$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_lawSync.actionTypes.FETCH_PROPOSAL_REQUEST, fetchProposal);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}
function watchFetchSyncOptions() {
    return regeneratorRuntime.wrap(function watchFetchSyncOptions$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return (0, _effects.takeLatest)(_lawSync.actionTypes.FETCH_SYNC_OPTIONS_REQUEST, fetchSyncOptions);

                case 2:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}
function watchApproveClause() {
    return regeneratorRuntime.wrap(function watchApproveClause$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeEvery)(_lawSync.actionTypes.APPROVE_CLAUSE_REQUEST, approveClause);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}
function watchRejectClause() {
    return regeneratorRuntime.wrap(function watchRejectClause$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    _context11.next = 2;
                    return (0, _effects.takeEvery)(_lawSync.actionTypes.REJECT_CLAUSE_REQUEST, rejectClause);

                case 2:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}
function watchEditProposalClause() {
    return regeneratorRuntime.wrap(function watchEditProposalClause$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeEvery)(_lawSync.actionTypes.EDIT_PROPOSAL_CLAUSE_REQUEST, editProposalClause);

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

exports.default = [watchFetchProposals, watchFetchProposal, watchFetchSyncOptions, watchApproveClause, watchRejectClause, watchEditProposalClause];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/lawSync.js
// module id = 2226
// module chunks = 0